import { Shared } from "./index";

/**
 * class: EventNames
 */
export class EventNames {
    static cameraChanged: string = "cameraChanged";
    // static itemsCleared: string = "itemsCleared";
    static wtPointChanged: string = "wtPointChanged";
    static wtAngleChanged: string = "wtAngleChanged";
    static wtHitCheck: string = "wtHitCheck"
    static orPointChanged: string = "orPointChanged";
    static orAngleChanged: string = "orAngleChanged";
    static wtFalling: string = "wtFalling";
    static wtObjectClicked: string = "wtObClk";
    static orObjectClicked: string = "orObClk";
    static cameraReset: string = "cameraReset";

    static wtMouseDown: string = 'wtMouseDown';
    static wtEndEvent: string = 'wtEndevent';
    static wtWheelEvent: string = 'wtWheelEvent'
    static wtKeyEvent: string = 'wtKeyEvent'

    // static deviceOrientationChanged: string = 'dvcorichg';
    // static deviceMotionChanged: string = 'dvcmotchg';
    // static deviceDetectEnabled: string = 'dvcdeton';
    // static deviceAccelSensorEnabled: string = 'dvcaccel';
}

/**
 * class: Options

 */
export class Options {
    _options: { [key: string]: boolean };
    constructor(options?: { plus?: string[], minus?: string[] }) {
        this._options = {};
        if (options != undefined) {
            let trues: string[] = options['plus'];
            if (trues != undefined) {
                for (var i = 0; i < trues.length; i++) {
                    this._options[trues[i]] = true;
                }
            }
            let falses: string[] = options['minus'];
            if (falses != undefined) {
                for (var i = 0; i < falses.length; i++) {
                    this._options[falses[i]] = false;
                }
            }
        }
    }
    public is(name: string, defaultValue: boolean): boolean {
        let value = this._options[name];
        if (value == undefined) return defaultValue;
        return value;
    }
}

/**
 * enum: Commands
 */
export enum Commands {
    go,
    back,
    stop,
    home,
}

/**
 * enum: OpeMode
 */
export enum OpeMode {
    create,
    operate,
    animate
}

/**
 * enum: ViewType
 */
export enum ViewType {
    wireframe,
    shading,
    texture,
}

/**
 * class: ViewOptions
 */
export class ViewOptions {
    static showNormals: string = "showNormals";
}

/**
 * class: ResetOptions
 */
export class ResetOptions {
    static resetEnv: string = "rtEv";
    static deleteCameras: string = "dlCm";
    static resetRenderer: string = "rtRr";
    static keepMotion: string = "kpMt";
}

/**
 * class: CameraDefs
 */
export class CameraDefs {
    static orbitCamNo: number = 0;
    static wlkthCamNo: number = 1;
    static orthCamNo: number = 2;
}

/**
 * class: DefNames
 */
export class DefNames {
    static terrain = "terrain";
}

/**
 * class: UrlDefs
 */
export class UrlDefs {
    static iconFolder = "icnfldr";
}

/**
 * class: TextureDefs
 */
export class TextureDefs {
    static get messageBoardTexPath() {
        return Shared.get().getUrl(UrlDefs.iconFolder) + 'texture3d/woodBoard.jpg';
    }
}

/**
 * class: MessageDefs
 */
export class MessageDefs {
    static unknownError = "<ja>不明のエラーです</ja><en>Unknown error.</en>";
}

/**
 * enum: WtCamCtrlMode
 */
export enum WtCamCtrlMode {
    wtButtons,
    wtJyro
}
